import { loader } from 'graphql.macro'

export default async function unlinkFeeTypeFromQbo ({ dataLoaders, variables }) {
  const schema = loader('./unlinkFeeTypeFromQbo.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    id: variables.id
  })
  return response.unlinkFeeTypeFromQbo
}
